import { apiserver } from "../api";

// Jira Ticket KW-342
// For more informations look up "Eval Funktionen Webshop.csv in the project root."
export async function knEval(id) {
  try {
    await apiserver.evaluation.postEvalData(id);
  } catch (e) {
    console.log({ e });
    return;
  }
}

export async function checkoutEval() {
  try {
    await apiserver.cart.postEvalData();
  } catch (e) {
    console.log({ e });
    return;
  }
}
// new field in  /api/product/{productNr}  (query)searchId

///api/cart/checkout
